import { FETCH_PET, FETCH_PET_DATA, FETCH_PET_MODAL,FETCH_PET_KIND_ID } from "./ActionTypes";

const initialState = {
  id: null, // localStorage.getItem("petId"),
  petData: [],
  petModal: false,
  petKindId:1
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PET:
      return {
        id: action.payload,
      };
      case "FETCH_PETUSERID":
        return {
          pet_UserId: action.pet_user_id,
        };

    case FETCH_PET_DATA:
      return {
        petData: action.petData,
      };

    case FETCH_PET_MODAL:
      return {
        petModal: action.petModal,
      };

      case FETCH_PET_KIND_ID:
        return {
          petKindId: action.petKindId,
        };
  
      
    default:
      return state;
  }
};

export default reducer;
